import api from './config';

export const simulate = async (params) => {
  try {
    const response = await api.get('/simulator', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};